export default "__VITE_ASSET__Duz58itH__"